export default __webpack_public_path__ + "static/media/tpdd.14e26c28.svg";